import axios from 'axios';

//process.env.API_BASE_URL_DEVELOP
const apiUrl = process.env.REACT_APP_API_BASE_URL_DEVELOP
//console.log("apiUrl",apiUrl);
const apiClient = axios.create({
  baseURL: apiUrl, // Base URL from .env
  headers: {
     'Content-Type': 'application/json',
    'crossOriginResourcePolicy': 'false'
  },
});

// Optional: Add interceptors for logging or error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiClient;